import React, { useEffect, useState } from 'react'
import { Button, Col, Form, InputGroup, Row, Table } from 'react-bootstrap'
import {
  BsArrowClockwise,
  BsFileEarmarkArrowUp,
  BsSearch,
  BsSliders2Vertical
} from 'react-icons/bs'
import { Controller, useForm } from 'react-hook-form'
import ModalFilterExpand from './expand-filter'
import { useSelector } from 'react-redux'
import { getOrgListAPI } from '../../../services/division'
import SpinnerLoading from '../../spinner-loading'
import { useDebounce } from '@react-hook/debounce'
import { BODYEXPAND, SEARCHEXPAND } from '../../../Constants'
import { saveAs } from 'file-saver'
import SwalCustom from '../../../alert/swal-custom'
import { createSpreadsheetBlob } from '../../../helper/spreadsheet/write-spreadsheet'
import { buildOrganizationExpandReportSheet } from '../../../helper/spreadsheet/organization-expand-report'

function Expand() {
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm()

  const orgId = useSelector((state) => state.roleReducer.role)

  const [onFilter, setOnFilter] = useState(false)
  const [dataTable, setDataTable] = useState([])
  const [search, setSearch] = useDebounce('', 1000)

  const [isLoading, setIsLoading] = useState(true)
  const [numLoad, setNumLoad] = useState(1)
  const [isExcel, setIsExcel] = useState(false)

  const [sumEmp, setSumEmp] = useState(0)
  const [sumHead, setSumHead] = useState(0)
  const bodyQuery = JSON.parse(localStorage.getItem(BODYEXPAND))

  useEffect(() => {
    const body = {
      orgId
    }
    if (orgId) {
      getOrgList(body)
      clearSearch()
    }
    setNumLoad(numLoad + 1)
  }, [orgId])

  const handleShowFilter = () => {
    setOnFilter(true)
  }

  const handleCloseFilter = () => {
    setOnFilter(false)
  }

  const getOrgList = async (body) => {
    const res = await getOrgListAPI(body)
    setIsLoading(false)

    if (!res) return
    if (res.status) {
      setDataTable(res.result)
      calculateSumEmp(res.result)
      calculateSumHead(res.result)
    }
  }

  const calculateSumEmp = (data) => {
    let totalEmpCount = 0
    for (const item of data) {
      totalEmpCount += item.count_emp
    }
    setSumEmp(totalEmpCount)
  }

  const calculateSumHead = (data) => {
    let totalEmpCount = 0
    for (const item of data) {
      totalEmpCount += item.headcount
    }
    setSumHead(totalEmpCount)
  }

  const onSearch = (d) => {
    setIsLoading(false)
    setSearch(d.search)
    localStorage.setItem(SEARCHEXPAND, JSON.stringify(d.search))

    const body = {
      searchs: d.search ?? search ?? '',
      orgId,
      division: bodyQuery?.divisions?.data ?? '',
      faction: bodyQuery?.faction?.data ?? '',
      department: bodyQuery?.department?.data ?? '',
      team: bodyQuery?.team?.data ?? '',
      position: bodyQuery?.position?.data ?? ''
    }
    getOrgList(body)
    setIsLoading(true)
  }
  const clearSearch = () => {
    setValue('search', '')
    setValue('orgSelect', [])
    setSearch(null)
    const body = { orgId }
    getOrgList(body)
    localStorage.removeItem(BODYEXPAND)
    localStorage.removeItem(SEARCHEXPAND)
  }

  const handleExportExcel = async () => {
    setIsExcel(true)
    try {
      const body = {
        searchs: search ?? '',
        orgId,
        division: bodyQuery?.divisions?.data ?? '',
        faction: bodyQuery?.faction?.data ?? '',
        department: bodyQuery?.department?.data ?? '',
        team: bodyQuery?.team?.data ?? '',
        position: bodyQuery?.position?.data ?? ''
      }
      const res = await getOrgListAPI(body)
      if (res.status) {
        const data = res.result.map((d, i) => {
          return {
            num: i + 1,
            division: d.division,
            faction: d.faction,
            department: d.department,
            team_en: d.team_en,
            level_id: d.level_id,
            position_en: d.position_en,
            headcount: d.headcount,
            count_emp: d.count_emp
          }
        })

        const filterEx = res.filters

        await exportExcel(data, 'Organization Expand Report', filterEx)
      }
    } finally {
      setIsExcel(false)
    }
  }

  const exportExcel = async (data, name, filterEx) => {
    const { sheetData, sheetOptions } = buildOrganizationExpandReportSheet({
      filterEx,
      data
    })
    const blob = await createSpreadsheetBlob(sheetData, sheetOptions)

    SwalCustom({
      title: 'Success!',
      text: 'Exported',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500
    })
    saveAs(blob, `${name}`)
  }

  return (
    <Row>
      {/* <h4 className="text-muted mb-0 align-content-lg-around">
            Organization Expand
          </h4> */}
      <Col
        xl={12}
        className="my-auto d-flex gap-3 justify-content-between mb-2 pt-1"
      >
        <Col xl={6} className="">
          <span
            style={{
              backgroundColor: '#CADEF5',
              padding: '1px 17px 1px 17px ',
              borderRadius: '5px'
            }}
            className="small me-2"
          >
            Total Head Count: {sumHead}
          </span>
          <span
            style={{
              backgroundColor: '#CADEF5',
              padding: '1px 17px 1px 17px ',
              borderRadius: '5px'
            }}
            className="small"
          >
            Total Employee: {sumEmp}
          </span>
        </Col>
        <Col xl={6} className="p-3 pt-0 pb-0">
          <div className="d-flex justify-content-end gap-2">
            <Form onSubmit={handleSubmit(onSearch)}>
              <Form.Group style={{ minWidth: 200 }}>
                <Controller
                  name={'search'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <InputGroup className="">
                      <InputGroup.Text className="bg-white border-end-0  text-muted">
                        <BsSearch />
                      </InputGroup.Text>
                      <Form.Control
                        value={value}
                        placeholder="Search..."
                        onChange={onChange}
                        className="border-start-0 ps-0 placeholder-text"
                      />
                    </InputGroup>
                  )}
                />
              </Form.Group>
            </Form>

            <Button
              size="sm"
              onClick={handleShowFilter}
              className=" text-primary border-0 px-4"
              type="button"
              variant="light"
            >
              <BsSliders2Vertical /> Filter
            </Button>

            <Button
              size="sm"
              type="button"
              variant="light"
              onClick={() => clearSearch()}
              className="text-primary border-0 "
            >
              <BsArrowClockwise />
            </Button>
            <span style={{ minWidth: '100px' }}>
              <Button
                size="sm"
                type="button"
                onClick={handleExportExcel}
                className="border-0 w-100"
              >
                <BsFileEarmarkArrowUp className="me-1 mb-1" />
                {isExcel ? 'Exporting' : 'Export'}
              </Button>
            </span>
          </div>
        </Col>
      </Col>

      <Col xl={12} className="">
        <Table responsive bordered hover className="mb-0">
          <thead
            className="bg-hrms"
            style={{ position: 'sticky', top: '0px', zIndex: 10 }}
          >
            <tr className="fw-light font-title-table">
              <th className="fw-normal small align-middle text-center">#</th>
              <th className="fw-normal small align-middle text-center">
                Group
              </th>
              <th className="fw-normal small align-middle text-center">
                Division
              </th>
              <th className="fw-normal small align-middle text-center">
                Department
              </th>

              <th
                className="fw-normal small align-middle"
                style={{
                  minWidth: '200px'
                }}
              >
                Team
              </th>
              <th
                className="fw-normal small align-middle text-center"
                style={{
                  minWidth: '20px'
                }}
              >
                Level
              </th>
              <th
                className="fw-normal small align-middle "
                style={{
                  minWidth: '250px'
                }}
              >
                Position
              </th>
              <th className=" fw-normal text-center">Computer Type</th>
              <th
                className="fw-normal small align-middle text-center"
                style={{
                  minWidth: '20px'
                }}
              >
                Head Count
              </th>

              <th
                className="fw-normal small align-middle text-center"
                style={{
                  minWidth: '20px'
                }}
              >
                Count of Employee
              </th>
            </tr>
          </thead>
          <tbody>
            {dataTable.length > 0 ? (
              dataTable.map((d, i) => (
                <tr className="mb-3 fw-light font-small-2 " key={i}>
                  <td className="text-center"> {i + 1}</td>
                  <td className="text-center">{d?.division ?? '-'}</td>
                  <td className="text-center">{d?.faction ?? '-'}</td>
                  <td className="text-center">{d?.department ?? '-'}</td>
                  <td>
                    <div>{d?.team_en ?? '-'}</div>
                    <div className="text-secondary">{d?.team_th ?? '-'}</div>
                  </td>
                  <td className="text-center">{d?.level_id ?? '-'}</td>

                  <td>
                    <div>{d?.position_en}</div>
                    <div className="text-secondary">
                      {d?.position_th ?? '-'}
                    </div>
                  </td>
                  <td className="text-center">{d.notebook_type_name}</td>

                  <td className="text-center">{d?.headcount ?? '-'}</td>
                  <td className="text-center">{d?.count_emp ?? '-'}</td>
                </tr>
              ))
            ) : isLoading ? (
              <tr className="mb-0">
                <td className="text-center" colSpan={10}>
                  <SpinnerLoading />
                </td>
              </tr>
            ) : (
              <tr>
                <td className="text-center" colSpan={10}>
                  -ไม่มีข้อมูล-
                </td>{' '}
              </tr>
            )}
          </tbody>
        </Table>
        {/* <div className="pt-3">
          <PaginationControl
            page={page}
            total={totalRows}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                page: p, 
                orgId,
                size: totalLimits
              }
              getOrgList(body)
              setPage(p)
            }}
            ellipsis={1}
          />
        </div> */}
      </Col>
      {onFilter && (
        <ModalFilterExpand
          orgId={orgId}
          onFilter={onFilter}
          handleCloseFilter={handleCloseFilter}
          getOrgList={getOrgList}
          setIsLoading={setIsLoading}
        />
      )}
    </Row>
  )
}

export default Expand
